export var Level = /* @__PURE__ */ ((Level2) => {
  Level2["ASSERTIVE"] = "assertive";
  Level2["POLITE"] = "polite";
  return Level2;
})(Level || {});
const liveAnnounceId = "uitk-live-announce";
const findOrCreateContainer = (id, ref) => {
  const container = document.createElement("div");
  container.id = id || liveAnnounceId;
  const refParentNode = document.body.querySelector(`#${id}`)?.parentNode;
  const bodyParentNode = document.body.querySelector(`#${liveAnnounceId}`)?.parentNode;
  if (ref) {
    if (refParentNode) {
      return refParentNode?.querySelector(`#${id}`);
    }
    return ref.current.appendChild(container);
  }
  if (!ref) {
    if (bodyParentNode) {
      return document.body.querySelector(`#${liveAnnounceId}`);
    }
    return document.body.appendChild(container);
  }
};
export const liveAnnounce = (msg = "", level = "assertive" /* ASSERTIVE */, className = "is-visually-hidden", ref, id) => {
  if (!(typeof document !== "undefined" && typeof document.querySelector === "function")) {
    return;
  }
  const liveRegion = findOrCreateContainer(id, ref);
  liveRegion.textContent = "";
  liveRegion.setAttribute("aria-live", level);
  liveRegion.setAttribute("class", className);
  liveRegion.textContent = msg;
};
